// extracted by mini-css-extract-plugin
module.exports = {"administration":"Administration-module--administration--KFlIF","wrapper":"Administration-module--wrapper--1wEdk","input":"Administration-module--input--3jMag"};